import { render, staticRenderFns } from "./ImportRequestSummary.vue?vue&type=template&id=b6b647e2"
import script from "./ImportRequestSummary.vue?vue&type=script&lang=js"
export * from "./ImportRequestSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports